import React from "react";
import { experienceFeatures, images } from "../data/mock";
import { Separator } from "./ui/separator";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import { programFlow, siteData } from "../data/mock";
import { Clock, MapPin, Calendar, ArrowRight } from "lucide-react";

export const ExperienceSectionBlack = () => {
  return (
    <section id="experience" className="py-[120px]" style={{ background: "#ffffff" }}>
      <div className="max-w-[87.5rem] mx-auto px-10">
        {/* Section Label */}
        <span
          className="inline-block text-[#6b7280] text-xs font-medium uppercase tracking-[0.2em] mb-6"
          style={{ fontFamily: "'Inter', Arial, sans-serif" }}
        >
          The Experience
        </span>

        <h2
          className="text-[#000000] uppercase leading-[0.85] mb-4"
          style={{
            fontFamily: "'Montserrat', Arial, sans-serif",
            fontWeight: 900,
            fontSize: "clamp(2rem, 1.5rem + 2vw, 3rem)",
          }}
        >
          A Premium Event
        </h2>
        <p
          className="text-[#1f2937] text-lg font-medium leading-relaxed max-w-2xl mb-16"
          style={{ fontFamily: "'Inter', Arial, sans-serif" }}
        >
          A premium, in-person leadership event designed to inspire, motivate, and create long-term impact.
        </p>

        {/* Event Card - Split Layout */}
        <div className="flex flex-wrap justify-start items-stretch min-h-[28rem] overflow-hidden mb-20" style={{ background: "#f9fafb" }}>
          {/* Left Content */}
          <div className="w-full md:max-w-[50%] p-10 md:p-16 flex flex-col justify-between min-h-[28rem]">
            <div>
              <h3
                className="text-[#000000] text-2xl uppercase mb-8"
                style={{ fontFamily: "'Montserrat', Arial, sans-serif", fontWeight: 900, lineHeight: 1.1 }}
              >
                What Awaits You
              </h3>
              <div className="space-y-5">
                {experienceFeatures.map((feature, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="w-6 h-6 rounded-full border border-[#000000] flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-[#000000] text-xs font-bold" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                        {i + 1}
                      </span>
                    </div>
                    <div>
                      <p
                        className="text-[#000000] text-sm font-semibold uppercase tracking-wider mb-1"
                        style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                      >
                        {feature.title}
                      </p>
                      <p
                        className="text-[#1f2937] text-sm font-medium leading-relaxed"
                        style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                      >
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="w-full md:max-w-[50%] min-h-[28rem] relative">
            <img
              src="/003-Shenkman-Arts-Centre-Exterior-1600x957.jpg"
              alt="Shenkman Arts Centre Exterior"
              className="w-full h-full object-cover absolute inset-0"
              loading="lazy"
            />
          </div>
        </div>

        {/* Creative Ribbon */}
        <div className="relative overflow-hidden mb-20" style={{ height: "12rem" }}>
          <div
            className="flex justify-center items-center w-[120%] h-[4.125rem] absolute left-[-10%]"
            style={{
              backgroundColor: "#e5e7eb",
              transform: "rotate(-2.5deg)",
              top: "15%",
            }}
          >
            <span
              className="text-[#000000] text-sm font-semibold uppercase tracking-[0.3em] whitespace-nowrap"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              Leadership &bull; Resilience &bull; Vision &bull; Purpose &bull; Leadership &bull; Resilience &bull; Vision &bull; Purpose &bull; Leadership &bull; Resilience
            </span>
          </div>
          <div
            className="flex justify-center items-center w-[120%] h-[4.125rem] absolute left-[-10%]"
            style={{
              backgroundColor: "#000000",
              transform: "rotate(2deg)",
              top: "50%",
            }}
          >
            <span
              className="text-[#ffffff] text-sm font-bold uppercase tracking-[0.3em] whitespace-nowrap"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              Built to Lead &bull; April 19th &bull; Ottawa &bull; Built to Lead &bull; April 19th &bull; Ottawa &bull; Built to Lead
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
